import { render } from "./MySubscriptionPage.vue?vue&type=template&id=c5f65c6e&scoped=true"
import script from "./MySubscriptionPage.vue?vue&type=script&lang=js"
export * from "./MySubscriptionPage.vue?vue&type=script&lang=js"

import "./MySubscriptionPage.vue?vue&type=style&index=0&id=c5f65c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f65c6e"]])

export default __exports__